import React from 'react';
import { ClipBoardIcon } from './helpers/svgHelper'
import { formatDecimal as fmt } from './helpers/paymentsHelper'

function Summary({ title, breakdown }) {

  const copyToClipboard = () => {
    const formattedData =
      `${title}\n\n` +
      Object.keys(breakdown)
        .map((key) => `${key}\n${fmt(breakdown[key].main, breakdown[key].precision)}\n\n`)
        .join('');

    navigator.clipboard.writeText(formattedData).then(
      () => alert('Copied to clipboard!'),
      (err) => alert('Failed to copy to clipboard', err)
    );
  };
  return (
    <div
      className="flex flex-col pt-2 p-4 rounded-lg shadow-xl w-full"
      style={{
        borderTop: '1px',
        borderTopColor: '#f2f2f3',
        background: 'white',
        boxShadow:
          '0 -2px 8px rgba(0, 0, 0, 0.05), 0 2px 8px rgba(0, 0, 0, 0.05)',
      }}>
      <div className="flex flex-row justify-between">
        <h4 className="text-base" style={{ color: '#656C7B' }}>
          {title}
        </h4>
        <button
          onClick={copyToClipboard}
          className="h-6 w-6 flex items-center justify-center bg-white border border-gray-300 rounded-md shadow-2xl">
          <ClipBoardIcon />
        </button>
      </div>

      <div
        className="w-full flex flex-row justify-between overflow-x-auto mt-4"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
        {Object.keys(breakdown).map((key, index) => {
          const precision = breakdown[key].precision;
          return (
            <div key={index} className="flex flex-col mr-4">
              <p className="font-light text-xs" style={{ color: '#A5A5A5' }}>
                {key}
              </p>
              <div className="flex flex-row">
                <p
                  className="font-medium"
                  style={{ fontSize: '14px', color: '#6E6C71' }}>
                  {breakdown[key].main === undefined ? '-' : fmt(breakdown[key].main, precision)}
                </p>
                {breakdown[key].brackets && (
                  <p
                    className="font-medium"
                    style={{ fontSize: '14px', color: '#6E6C71' }}>
                    ( {fmt(breakdown[key].brackets, precision)} )
                  </p>
                )}
                  <p
                    className={`font-medium ${breakdown[key].diff < 0 ? 'text-red-600' : 'text-green-600'}`}
                    style={{ fontSize: '10px' }}
                  >
                    {fmt(breakdown[key].diff, precision)}
                  </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Summary;
